import styled from "styled-components";

export const FormWrap = styled.div`
  background-color: #0d0d0d;
`;
